module.exports = __webpack_public_path__ + "static/media/branding-logo.705712a5.png";